<template lang="html">
  <div>
    <div class="container container-small">
      <div class="top-btn">
        <router-link :to="{ name: 'add-profile' }">
          <button type="submit" class="main-btn">
            {{ $t("btn_add_profile") }} <i class="fas fa-plus"></i>
          </button>
        </router-link>
      </div>
      <div class="profiles" v-if="!loading && profiles">
        <template>
          <div class="profile remove-a" v-for="profile in profiles">
            <router-link
              :to="{ name: 'edit-profile', params: { id: profile.id } }"
            >
              <Profile :profile="profile"></Profile>
            </router-link>
            <div class="action-buttons">
              <div class="d-flex justify-content-end mt-sm-4 mt-2">
                <router-link
                  :to="{ name: 'edit-profile', params: { id: profile.id } }"
                  class="edit-btn"
                >
                  <span class="edit-icon"></span>
                </router-link>
                <span class="trash-btn" v-on:click.stop="remove(profile.id)">
                  <span class="delete-icon"></span>
                </span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <template v-else>
        <div class="alert alert-info text-center mt-2 mb-2">
          {{ $t("profiles_no_profile") }}
        </div>
      </template>
    </div>
    <div class="container pb-4">
      <div class="bottom-action-button text-center">
        <router-link :to="{ name: 'add-profile' }">
          <button type="submit" class="main-btn">
            {{ $t("btn_add_profile") }} <i class="fas fa-plus"></i>
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import Profile from "./Profile.vue"

export default {
  name: "Profiles",
  components: {
    Profile,
  },
  data: function () {
    return {
      loading: true,
      delete_profile_id: false,
      profileId: null,
    }
  },
  computed: {
    ...mapState("profiles", ["profiles"]),
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions("profiles", {
      actionGetProfiles: "getProfiles",
      actionDeleteProfile: "deleteProfile",
    }),

    async init() {
      let response = await this.actionGetProfiles()
      this.loading = false
    },

    remove(id) {
      this.profileId = id

      this.$dialog
        .confirm({
          title: this.$t("edit_profile_delete_profile_title"),
          message: this.$t("edit_profile_delete_profile"),
          cancelButtonText: this.$t("no"),
          confirmButtonText: this.$t("yes"),
          beforeClose: this.doRemoveProfile,
        })
        .then(() => {
          this.init()
        })
        .catch(() => {
          // on cancel
        })
    },

    doRemoveProfile(action, done) {
      if (action == "confirm") {
        this.actionDeleteProfile(this.profileId)
          .then(async (response) => {
            done()
          })
          .catch(async (err) => {
            await done()
            if (err.response) {
              this.$dialog.alert({
                message: err.response.data.error.error_msg,
                confirmButtonText: this.$t("btn_i_understand"),
              })
            }
          })
      } else {
        done()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$lightgrey: lightgrey;
$green: #59af54;
$light-grey: #d6d6d6;

.profiles {
  padding-top: 10px;
  padding-bottom: 22px;

  .profile {
    border-radius: 4px;
    padding: 20px;
    margin: 18px 0px;
    position: relative;
    background: #eeedec;
  }
}

.top-btn {
  margin: 30px 0px 15px;
  text-align: right;

  .main-btn {
    font-size: 14px;

    @media only screen and (min-width: 769px) {
      max-width: 230px;
    }
  }
}

.main-btn {
  font-size: 16px;
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
}
.bottom-action-button {
  @media only screen and (max-width: 768px) {
    padding-bottom: 38px;
  }

  .main-btn {
    @media only screen and (min-width: 769px) {
      max-width: 360px;
    }
  }
}

.edit-btn {
  font-size: 18px;

  @media only screen and (min-width: 768px) {
    margin-right: 35px;
  }

  @media only screen and (max-width: 768px) {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #faf9f6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }
}

.trash-btn {
  font-size: 18px;
  cursor: pointer;

  @media only screen and (max-width: 768px) {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #faf9f6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.alert-info {
  background: #eeedec;
  border: none;
}
</style>
